// Test IDs for the customer monitoring empty state.

export const MONITORING = {
  emptyState: "monitoring-empty-state",
  tabStrip: "monitoring-tab-strip",
  referButton: "monitoring-empty-refer-button",
  supportButton: "monitoring-empty-support-button",
  referEarnButton: "monitoring-refer-earn-button",
  technicalDetails: "monitoring-technical-details",
  chartUpdated: "monitoring-chart-updated",
  todayPerformanceUnavailable: "monitoring-today-performance-unavailable",
  co2Info: "monitoring-co2-info",
  siteSelector: "monitoring-site-selector",
};

// Test IDs for the admin Solar Sites ERP Project link.

export const ADMIN_SOLAR_SITES = {
  addViewer: "solar-site-add-viewer",
  removeViewer: "solar-site-remove-viewer",
  projectBadge: "solar-site-project",
  projectDialog: "erp-project-link-dialog",
  projectSearchInput: "erp-project-search-input",
  projectSearchButton: "erp-project-search-button",
  projectResult: "erp-project-result",
  projectLinkButton: "erp-project-link-button",
  projectLinkAction: "solar-site-link-project",
  latInput: "solar-site-lat-input",
  lonInput: "solar-site-lon-input",
  projectUnlinkAction: "solar-site-unlink-project",
  setupSupport: "solar-site-setup-support",
  siteNotice: "solar-site-notice",
};
